var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 287,
    height: 306,
    viewBox: "0 0 287 306",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M257.7 152.9V76.5L181.4 0H28.5V152.9H0V248.4H28.5V305.7H257.7L258 248.4H286.5V152.9H257.7Z",
    fill: "#1D6F42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.1 85.9V9.60001H38.1V152.9H248.3V85.9H172.1ZM181.4 12.9V76.5H245L181.4 12.9ZM38.1 296.1H248.3V248.3H38.1V296.1Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126.312 222L108.888 197.304L125.232 173.976H112.92L102.048 190.392L91.0319 173.976H78.8639L95.2079 197.376L77.7839 222H89.9519L102.048 204.432L114.072 222H126.312Z",
    fill: "#F9F9F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M161.014 222V213H140.71V173.976H130.414V222H161.014Z",
    fill: "#F9F9F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M185.036 222.864C197.924 222.864 204.26 216.24 204.26 207.456C204.26 189.528 176.684 194.64 176.684 187.08C176.684 184.2 179.132 182.328 183.452 182.328C188.348 182.328 193.532 183.984 197.42 187.584L203.108 179.952C198.356 175.56 192.02 173.256 184.388 173.256C173.084 173.256 166.172 179.88 166.172 187.872C166.172 205.944 193.82 200.112 193.82 208.464C193.82 211.272 191.156 213.792 185.468 213.792C178.844 213.792 173.588 210.768 170.204 207.24L164.588 215.232C169.124 219.768 175.748 222.864 185.036 222.864Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXls);
export default __webpack_public_path__ + "static/media/xls.04dfd0f6f3516ea88b1b3eb7579d6a25.svg";
export { ForwardRef as ReactComponent };